import React, { useEffect } from "react";
import { usePostHog } from "posthog-js/react";
import { useAuth } from "@consumerig/iv-components";

const PostHogIdentityProvider = ({ children }) => {
  const { user } = useAuth();
  const posthog = usePostHog();

  useEffect(() => {
    posthog?.identify(user.user_id, {
      email: user.user_email,
      username: user.username,
      name: `${user.user_fname} ${user.user_lname}`,
      company: user.company.company_id,
    });
  }, [posthog, user]);

  return <>{children}</>;
};

export default PostHogIdentityProvider;
